'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = init;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} html
 *
 * Replace HTML entities with original characters
 */
function decodeHTML(html) {
  var textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
}

/** @param {{
 *  el: HTMLElement
 *  context: {
 *    className: string
 *    getElement: (selector: string) => HTMLElement
 *    getElements: (selector: string) => HTMLElement[]
 *  }
 * }} options
 */
function init(_ref) {
  var getBuildABoxSubProducts = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _ref3, globalBuildABoxProducts, lineItemHasCocktailSubProducts, isCocktailSubProductProperty, productToSubProductMap, buildABoxItems;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isCocktailSubProductProperty = function isCocktailSubProductProperty(_ref6) {
                var _ref7 = (0, _slicedToArray3.default)(_ref6, 1),
                    key = _ref7[0];

                return (/^Cocktail/.test(key)
                );
              };

              lineItemHasCocktailSubProducts = function lineItemHasCocktailSubProducts(lineItem) {
                return lineItem.properties.some(function (_ref4) {
                  var _ref5 = (0, _slicedToArray3.default)(_ref4, 1),
                      key = _ref5[0];

                  return key === 'Cocktail 1';
                });
              };

              _context.next = 4;
              return fetch('/collections/build-a-box/products.json').then(function (response) {
                return response.json();
              });

            case 4:
              _ref3 = _context.sent;
              globalBuildABoxProducts = _ref3.products;


              /** @type {Map<{}, string[]>} */
              productToSubProductMap = new _map2.default();
              buildABoxItems = lineItems.all.filter(lineItemHasCocktailSubProducts);

              buildABoxItems.forEach(function (item) {
                var componentCocktails = item.properties.filter(isCocktailSubProductProperty).map(function (_ref8) {
                  var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
                      title = _ref9[1];

                  return title;
                });

                var cocktails = componentCocktails.map(function (cocktail) {
                  /**
                   * When added to the cart, cocktail names sometimes
                   * have special HTML characters in them
                   */
                  var decodedTitle = decodeHTML(cocktail);
                  var product = globalBuildABoxProducts.find(function (product) {
                    return product.title === decodedTitle;
                  });

                  return product;
                });

                productToSubProductMap.set(item, cocktails);
              });

              return _context.abrupt('return', productToSubProductMap);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function getBuildABoxSubProducts() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getUnavailableSubProducts = function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', getBuildABoxSubProducts().then(function (products) {
                var productsWithUnmatchedSubProducts = [].concat((0, _toConsumableArray3.default)(products)).filter(function (_ref11) {
                  var _ref12 = (0, _slicedToArray3.default)(_ref11, 2),
                      subProducts = _ref12[1];

                  return subProducts.some(function (product) {
                    return !product;
                  });
                });

                var productsWithUnavailableSubProductVariants = [].concat((0, _toConsumableArray3.default)(products)).filter(function (_ref13) {
                  var _ref14 = (0, _slicedToArray3.default)(_ref13, 2),
                      subProducts = _ref14[1];

                  return subProducts.some(function (product) {
                    return !product.variants.every(function (variant) {
                      return variant.available;
                    });
                  });
                });

                return [].concat((0, _toConsumableArray3.default)(productsWithUnmatchedSubProducts), (0, _toConsumableArray3.default)(productsWithUnavailableSubProductVariants));
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function getUnavailableSubProducts() {
      return _ref10.apply(this, arguments);
    };
  }();

  var getUnavailableItems = function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      var unavailableBuildABoxProducts;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = [];
              _context3.t1 = _toConsumableArray3.default;
              _context3.next = 4;
              return unavailableSubProducts;

            case 4:
              _context3.t2 = _context3.sent;
              _context3.t3 = (0, _context3.t1)(_context3.t2);

              _context3.t4 = function (_ref16) {
                var _ref17 = (0, _slicedToArray3.default)(_ref16, 1),
                    product = _ref17[0];

                return product;
              };

              unavailableBuildABoxProducts = _context3.t0.concat.call(_context3.t0, _context3.t3).map(_context3.t4);
              return _context3.abrupt('return', [].concat((0, _toConsumableArray3.default)(lineItems.unavailable), (0, _toConsumableArray3.default)(unavailableBuildABoxProducts)));

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function getUnavailableItems() {
      return _ref15.apply(this, arguments);
    };
  }();

  /** @param {MouseEvent} event */
  var handleSubmitClick = function () {
    var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(event) {
      var unavailableItems, items;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event.preventDefault();

              _context4.next = 3;
              return getUnavailableItems();

            case 3:
              unavailableItems = _context4.sent;

              if (!(unavailableItems.length > 0)) {
                _context4.next = 8;
                break;
              }

              setUnavailableItems(elements.unavailableItems, unavailableItems);
              openModal(elements.confirmationModal);

              return _context4.abrupt('return');

            case 8:
              items = lineItems.all.map(function (lineItem) {
                return {
                  id: lineItem.variant_id,
                  quantity: lineItem.quantity,
                  properties: Object.fromEntries(lineItem.properties)
                };
              });


              addToCart(items);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    return function handleSubmitClick(_x) {
      return _ref18.apply(this, arguments);
    };
  }();

  var addToCart = function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return fetch('/cart/add', {
                body: (0, _stringify2.default)({ items: items }),
                credentials: 'same-origin',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 2:

              window.location.href = '/cart';

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    return function addToCart() {
      return _ref19.apply(this, arguments);
    };
  }();

  /** @param {HTMLElement} modal */


  var el = _ref.el,
      context = _ref.context;

  var elements = {
    submit: context.getElement('[data-el="reorder.submit"]'),
    confirmationModal: context.getElement('[data-el="reorder.confirmation-modal"]'),
    confirmationClose: context.getElement('[data-el="reorder.confirmation-close"]'),
    unavailableItems: context.getElement('[data-el="reorder.unavailable-items"]')
  };

  var unavailableVariantIds = JSON.parse(el.dataset.unavailableVariantIds);

  var lineItems = {
    /** @type {{}[]} */
    all: JSON.parse(el.dataset.lineItems),
    get available() {
      var _this = this;

      return this.all.filter(function (lineItem) {
        return !_this.unavailable.includes(lineItem);
      });
    },
    get unavailable() {
      return this.all.filter(function (lineItem) {
        return unavailableVariantIds.includes(lineItem.variant.id);
      });
    }
  };

  var unavailableSubProducts = getUnavailableSubProducts();

  getUnavailableItems();function openModal(modal) {
    modal.setAttribute('aria-hidden', false);
  }

  /** @param {HTMLElement} modal */
  function closeModal(modal) {
    modal.setAttribute('aria-hidden', true);
  }

  function setUnavailableItems(list, lineItems) {
    list.innerHTML = lineItems.map(function (lineItem) {
      return '<li class="acc-Reorder_UnavailableItem">' + lineItem.title + '</li>';
    });
  }

  elements.submit.addEventListener('click', handleSubmitClick);
  elements.confirmationClose.addEventListener('click', function () {
    return closeModal(elements.confirmationModal);
  });
}